export default __webpack_public_path__ + "static/hold_ticket_white-5ac4f98dc07ab38c83d0175d7d3e20ea.png";